import axiosClient from '../../config/axios';

export function confirmSetPasswordRequest(data: { signature: string }) {
  return axiosClient.mutate.post('/api/v1/verify-invitation', data);
}
